<template>
  <button
    class="confirm-special-button inline-block"
    :class="{ triggered: triggered }"
    @touchstart="onTouchStart"
    @touchend="onTouchEnd"
    @mousedown="onMouseDown"
    @click="onClick"
  >
    <img
      class="select-none pointer-events-none"
      src="@/assets/icons/genicon-confirm-special.svg"
    />
  </button>
</template>

<script>
export default {
  name: "ConfirmSpecialButton",
  data: () => {
    return {
      isTouchAction: false,
      triggered: false
    };
  },
  methods: {
    onClick(event) {
      this.$emit("click", event);
    },
    onMouseDown() {
      if (process.env.VUE_APP_PLATFORM === "ios") {
        // iOS fires mouse events after touchend, even after dragging which causes funky behaviour
        return;
      }
      if (this.isTouchAction) {
        return;
      }
      this.onPointerDown();
    },
    onTouchStart() {
      this.isTouchAction = true;
      this.onPointerDown();
    },
    onTouchEnd() {
      this.isTouchAction = false;
    },
    onPointerDown() {
      this.triggered = true;
      setTimeout(() => {
        this.triggered = false;
      }, 500);
    }
  }
};
</script>

<style scoped>
.confirm-special-button {
  -webkit-appearance: none;
  width: 5.5rem;
  -webkit-animation: breathe 3s ease-in-out infinite;
  animation: breathe 3s ease-in-out infinite;
  border-radius: 50%;
  transition: transform 0.5s ease, -webkit-transform 0.5s ease;
}
.confirm-special-button > img {
  position: relative;
  -webkit-appearance: none;
  -webkit-box-shadow: rgba(255, 255, 0, 1) 0 0 2rem;
  box-shadow: rgba(255, 255, 0, 1) 0 0 2rem;
  border-radius: 50%;
}
#app.mouse .confirm-special-button:hover {
  cursor: pointer;
  opacity: 0.9;
}
#app.mouse .confirm-special-button:hover img,
.confirm-special-button:active img {
  filter: brightness(120%);
}
.confirm-special-button.triggered img {
  animation: plop 0.5s ease;
  -webkit-animation: plop 0.5s ease;
}
@keyframes breathe {
  0% {
    transform: scale(1);
    -webkit-transform: scale(1);
  }
  50% {
    transform: scale(1.3);
    -webkit-transform: scale(1.3);
  }
  100% {
    transform: scale(1);
    -webkit-transform: scale(1);
  }
}
@keyframes plop {
  0% {
    transform: scale(1);
    -webkit-transform: scale(1);
  }
  25% {
    transform: scale(0.5);
    -webkit-transform: scale(0.5);
  }
  50% {
    transform: scale(1.3);
    -webkit-transform: scale(1.3);
  }
  100% {
    transform: scale(1);
    -webkit-transform: scale(1);
  }
}
@media screen and (min-width: 768px) {
  .confirm-special-button {
    width: 5.75rem;
  }
}
</style>
